import { render, staticRenderFns } from "./ResetPasswordDone.vue?vue&type=template&id=5ef5d764&scoped=true&"
import script from "./ResetPasswordDone.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordDone.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/password.css?vue&type=style&index=0&id=5ef5d764&prod&scoped=true&lang=css&"
import style1 from "./ResetPasswordDone.vue?vue&type=style&index=1&id=5ef5d764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef5d764",
  null
  
)

export default component.exports